/* global grecaptcha */

// Function to initialize the form once reCAPTCHA is loaded
function initializeQuoteForm() {
  // Add design tool data to form if it exists
  const formData = JSON.parse(localStorage.getItem('formData') || '{}');
  const hiddenFieldsContainer = document.getElementById('hidden-design-fields');

  if (formData.design || formData.product) {
    // Helper function to create hidden fields
    function addHiddenField(name, value) {
      if (value !== null && value !== undefined && value !== '') {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = typeof value === 'object' ? JSON.stringify(value) : value;
        hiddenFieldsContainer.appendChild(input);
      }
    }

    // Add design fields
    if (formData.design) {
      addHiddenField('quote_form[design][id]', formData.design.id);
      addHiddenField('quote_form[design][url]', formData.design.url);
      addHiddenField('quote_form[design][art_code]', formData.design.artCode);
      addHiddenField(
        'quote_form[design][design_url]',
        formData.design.designUrl
      );
    }

    // Add product fields
    if (formData.product) {
      addHiddenField('quote_form[product][id]', formData.product.id);
      addHiddenField(
        'quote_form[product][description]',
        formData.product.description
      );
      addHiddenField('quote_form[product][name]', formData.product.name);
      addHiddenField('quote_form[product][style]', formData.product.style);
      addHiddenField(
        'quote_form[product][brand_name]',
        formData.product.brandName
      );
      addHiddenField(
        'quote_form[product][product_url]',
        formData.product.productUrl
      );
    }

    // Add product color fields
    if (formData.productColor) {
      addHiddenField('quote_form[product_color][id]', formData.productColor.id);
      addHiddenField(
        'quote_form[product_color][name]',
        formData.productColor.name
      );
      addHiddenField(
        'quote_form[product_color][hex_code]',
        formData.productColor.hexCode || formData.productColor.hex_code
      );
      addHiddenField(
        'quote_form[product_color][marketing_image_url]',
        formData.productColor.marketingImageUrl ||
          formData.productColor.marketing_image_url
      );
    }

    // Add design customization (complex nested object)
    if (formData.designCustomization) {
      // Remove large SVG content before adding to form
      const customization = { ...formData.designCustomization };
      delete customization.sideSvgContent;
      delete customization.side_svg_content;
      delete customization.designPoolSvgContent;
      delete customization.design_pool_svg_content;

      // Add each property as a separate hidden field
      Object.keys(customization).forEach(key => {
        const value = customization[key];
        if (value !== null && value !== undefined) {
          if (typeof value === 'object') {
            addHiddenField(
              `quote_form[design_customization][${key}]`,
              JSON.stringify(value)
            );
          } else {
            addHiddenField(`quote_form[design_customization][${key}]`, value);
          }
        }
      });
    }
  }

  // Handle student checkbox toggle
  const studentCheckbox = document.getElementById('quote_form_is_student');
  const studentFields = document.querySelector('.js-student-fields');
  const businessFields = document.querySelector('.js-business-fields');

  if (studentCheckbox) {
    // Function to update field visibility and required attributes
    function updateFieldRequirements() {
      const isStudent = !studentCheckbox.checked;

      if (studentFields) {
        studentFields.style.display = isStudent ? '' : 'none';
        // Update required attributes for student fields
        const schoolField = document.getElementById('quote_form_school');
        if (schoolField) {
          schoolField.required = isStudent;
        }
      }

      if (businessFields) {
        businessFields.style.display = isStudent ? 'none' : '';
        // Update required attributes for business fields
        const businessNameField = document.getElementById(
          'quote_form_business_name'
        );
        if (businessNameField) {
          businessNameField.required = !isStudent;
        }
      }
    }

    // Set initial state
    updateFieldRequirements();

    // Update on change
    studentCheckbox.addEventListener('change', updateFieldRequirements);
  }

  // Phone number formatting
  const phoneField = document.getElementById('quote_form_phone_number');
  if (phoneField) {
    phoneField.addEventListener('input', function(e) {
      let value = e.target.value.replace(/\D/g, '');
      if (value.length > 3 && value.length <= 6) {
        value = value.slice(0, 3) + '-' + value.slice(3);
      } else if (value.length > 6) {
        value =
          value.slice(0, 3) +
          '-' +
          value.slice(3, 6) +
          '-' +
          value.slice(6, 10);
      }
      e.target.value = value;
    });
  }

  // Initialize form submission with reCAPTCHA
  const quoteForm = document.getElementById('quote-request-form');
  if (!quoteForm) return;

  quoteForm.addEventListener('submit', function(e) {
    e.preventDefault();

    const submitButton = e.target.querySelector('[type="submit"]');
    submitButton.disabled = true;
    submitButton.value = 'Submitting...';

    grecaptcha.ready(() => {
      grecaptcha
        .execute(window.googleRecaptchaSiteKey, { action: 'quote_form' })
        .then(token => {
          // Add token to form
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'g-recaptcha-response';
          input.value = token;
          e.target.appendChild(input);

          // Submit form
          e.target.submit();
        })
        .catch(error => {
          console.error('reCAPTCHA error:', error);
          submitButton.disabled = false;
          submitButton.value = 'Submit Quote Request';
          alert('Security check failed. Please try again.');
        });
    });
  });
}

// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', function() {
  // Check if reCAPTCHA is already loaded
  if (typeof grecaptcha !== 'undefined') {
    initializeQuoteForm();
  } else {
    // Wait for reCAPTCHA to load
    let attempts = 0;
    const maxAttempts = 50; // 5 seconds max wait
    
    const checkRecaptcha = setInterval(() => {
      attempts++;
      
      if (typeof grecaptcha !== 'undefined') {
        clearInterval(checkRecaptcha);
        initializeQuoteForm();
      } else if (attempts >= maxAttempts) {
        clearInterval(checkRecaptcha);
        console.error('reCAPTCHA failed to load after 5 seconds');
        
        // Show error message to user
        const quoteForm = document.getElementById('quote-request-form');
        if (quoteForm) {
          const errorDiv = document.createElement('div');
          errorDiv.className = 'alert alert--error mbm';
          errorDiv.textContent = 'Security verification failed to load. Please refresh the page and try again.';
          quoteForm.insertBefore(errorDiv, quoteForm.firstChild);
        }
      }
    }, 100);
  }
});